import React from 'react';
import PropTypes from 'prop-types';

import { GlossaryEntry } from '../../../../common/glossary-entry';
import { Separator } from '../../separator';
import { GlossaryText } from '../../../../models/GlossaryText';
import UpArrowIcon from '../../../../assets/images/icon-drop-up.svg';
import DownArrowIcon from '../../../../assets/images/icon-drop-down.svg';
import styles from './FAQ.css';

const IPropTypes = {
  questionData: PropTypes.shape({
    question: PropTypes.string,
    answer: PropTypes.arrayOf(PropTypes.instanceOf(GlossaryText)),
  }).isRequired,
};

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: false,
    };

    this._toggleContent = this._toggleContent.bind(this);
  }

  _toggleContent() {
    this.setState(prevState => ({
      showContent: !prevState.showContent,
    }));
  }

  render() {
    const { questionData } = this.props;
    return (
      <div>
        <button className={styles.questionText} onClick={this._toggleContent}>
          {questionData.question}
          {
            this.state.showContent ?
              <img className={styles.arrow} src={UpArrowIcon} alt="" />
            :
              <img className={styles.arrow} src={DownArrowIcon} alt="" />
          }
        </button>
        {
          this.state.showContent &&
          questionData.answer.map(value => (
            <p className={styles.answerText} key={value.entries[0].text}>
              <GlossaryEntry entry={value} />
            </p>
          ))
        }
        <Separator />
      </div>
    );
  }
}

FAQ.propTypes = IPropTypes;

export { FAQ };



// WEBPACK FOOTER //
// ./src/pages/product-detail/faq-section/faq/FAQ.jsx